import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { FaArrowUp } from "react-icons/fa";

import "./ScrollToTop.css";

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  const { pathname, search } = useLocation();

  /* ========================================================
     AUTOMATIC SCROLL TO TOP ON ROUTE CHANGE
  ======================================================== */

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  }, [pathname, search]);

  /* ========================================================
     SHOW FLOATING BUTTON AFTER SCROLLING
  ======================================================== */

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    toggleVisibility();

    window.addEventListener("scroll", toggleVisibility);

    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  /* ========================================================
     MANUAL SMOOTH SCROLL TO TOP
  ======================================================== */

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  /* ========================================================
     RENDER
  ======================================================== */

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.button
          type="button"
          className="scroll-to-top"
          onClick={scrollToTop}
          initial={{
            opacity: 0,
            y: 20,
          }}
          animate={{
            opacity: 1,
            y: 0,
          }}
          exit={{
            opacity: 0,
            y: 20,
          }}
          transition={{
            duration: 0.3,
          }}
          aria-label="Scroll to top"
          title="Back to top"
        >
          <FaArrowUp className="scroll-icon" />
        </motion.button>
      )}
    </AnimatePresence>
  );
};

export default ScrollToTop;